import React from 'react'
import { useField } from 'react-final-form'
import useTranslate from '../../i18n/useTranslate'
import { composeValidators, selectRequired } from '../../utilities/validate'
import { UseCheckboxGroupProps } from './checkboxType'

export type FieldRequired = boolean | { showAsterisk?: boolean; triggedValidate?: boolean; errorMessage?: string }

function useCheckbox(props: UseCheckboxGroupProps) {
    const { name, required, validates = [], onChangeValue } = props
    const translate = useTranslate()
    let mergeValidate = validates
    if ((typeof required === 'boolean' && required) || (typeof required === 'object' && required.triggedValidate)) {
        mergeValidate = [
            selectRequired(typeof required === 'object' ? required.errorMessage : `${translate.get('MESSAGE.M016')}`),
            ...mergeValidate,
        ]
    }
    /* Validate */
    const field = useField<string>(name, {
        validate: composeValidators(...mergeValidate),
    })

    const handleChange = (evt: any, nameKeyValue?: number) => {
        field.input.onChange(evt)

        // ---1. ยังไม่ถูกติ๊ก --- //

        // ---2. ถูกติ๊กอยู่ --- //
        if (onChangeValue) {
            onChangeValue(evt)
        }
    }

    return { field, onChange: handleChange }
}

export default useCheckbox
